<template>
  <div>
    <!-- <div
      class="content"
      :style="{ backgroundImage: `url(${bannerImg})` }"
    >

    </div> -->
    <el-carousel class="content" :interval="5000" :autoplay="isAutoplay" ref="carousel"
                 @mouseenter.native="pauseCarousel" @mouseleave.native="startCarousel">
      <el-carousel-item
          class="content_item"
          v-for="item in bannerImg"
          :key="item.url"
          :style="{ backgroundImage: `url(${item.url})` }"
          @click.native="jumpBtn(item)"
      >
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="Introduction">
        <div class="Introduction_card">
          <div
            class="MagicCard"
            v-for="(item, index) in magicData"
            :key="index"
            @click="jumpBtn(item)"
          >
            <div class="Card_content">
              <div class="Card_img">
                <img :src="baseUrl+ item.imageUrl" alt="" />
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    <div class="ProductIntroduction" v-if="false">
      <div class="ProductIntroduction_backgr">
        <div class="ProductIntroduction_backgr_title">
          <img :src="titleImg" alt=""/>
          <span>关于我们</span>
        </div>
      </div>
      <div class="ProductIntroduction_info">
        <div class="ProductIntroduction_info_warpper">
          <div class="ProductIntroduction_info_warpper_quotation">
            <img :src="quotation_right" alt="右引号"/>
          </div>
          <div
              class="ProductIntroduction_info_warpper_content"
              v-html="instraction"
          />
          <div
              class="ProductIntroduction_info_warpper_quotation ProductIntroduction_info_warpper_quotation_left"
          >
            <img :src="quotation_left" alt="左引号"/>
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="common_title">天府码上收</p>
    <div class="one_click_recycling">
      <div class="recycling_content">
        <p class="recycling_descript">
          通过构建资源回收平台，解决再生资源行业上游回收分散的难点，解决卖废端找不到资源回收渠道的难题，降低资源回收中运输难度，避免回收过程中对环境造成不必要的污染。
        </p>
        <div class="QR_code">
          <img :src="qrCode" alt="" />
          <p>二维码</p>
        </div>
      </div>
    </div> -->
    <p class="common_title">我们能做什么</p>
    <!-- <p class="common_description">What can we do</p> -->
    <div class="canWeDo">
      <div class="canWeDo_box">
        <div class="canWeDo_warpper">
          <div
              v-for="(item, index) in functionIntroduction"
              :key="index"
              class="canWeDo_warpper_card"
              @click="gotoDetail(item)"
          >
            <div class="canWeDo_warpper_card_title">
              <img :src="item.url" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Outlets" v-if="false">
      <div class="Outlets_warpper">
        <div class="Outlets_title">
          <img :src="titleImg" alt=""/>
          <span>产业体系分布</span>
        </div>
        <div class="Outlets_content">
          <div class="Outlets_content_left">
            <div class="Outlets_content_left_box">
              <div
                  class="Outlets_content_left_totle"
                  v-for="item in distribution"
              >
                <div class="Outlets_content_left_totle_name">
                  {{ item.title }}
                </div>
                <div class="Outlets_content_left_totle_nums">
                  {{ item.nums }}
                </div>
              </div>
            </div>
          </div>
          <div class="Outlets_content_right">
            <home-echarts/>
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="common_title">绿色产业，有序循环</p>
    <p class="common_description">深入行业链条，聚集企业服务，打造绿色产业</p>
    <div class="product_explanation">
      <div class="product_content">
        <div class="product_overlay"></div>
        <div class="about-us-link">
          <span @click="jumpToAbout">关于我们 >></span>
        </div>
      </div>
    </div> -->
    <p class="common_title">政策资讯</p>
    <!-- <p class="common_description">News Center</p> -->
    <div class="consultation">
      <div class="consultation-container">
        <div
            v-for="(item, index) in newData"
            :key="item.id || index"
            class="consultation-item"
        >
          <!-- 图片区域 -->
          <div class="consultation-image" v-if="item.imageUrl">
            <img :src="item.imageUrl" :alt="item.title"/>
            <div class="image-hover-content">
              <div class="image-hover-title">{{ item.title }}</div>
              <button class="view-details-btn" @click="lookDetail(item)">
                查看详情
              </button>
            </div>
          </div>

          <!-- 内容区域 -->
          <div class="consultation-content">
            <h3 class="consultation-title">
              {{ item.title }}
            </h3>

            <div class="consultation-meta" v-if="item.time">
              <span class="consultation-time">{{ item.time }}</span>
            </div>
            <div class="consultation-more" @click="lookMore">更多></div>
          </div>
        </div>
        <div class="more" @click="lookMore">更多 >></div>
      </div>
    </div>
    <div class="necessary_link">
      <p>友情链接：</p>
      <div class="item">
        <el-select
            v-model="partyCommitteeValue"
            placeholder="党委政府"
            @change="handlePartyCommitteeChange"
            popper-class="transparent-dropdown"
            :popper-append-to-body="false"
        >
          <el-option
              v-for="item in partyCommittee"
              :key="item.value"
              :label="item.title"
              :value="item.linkUrl"
          >
          </el-option>
        </el-select>


        <el-select
            v-model="centralValue"
            placeholder="国家部委"
            @change="handleCentralChange"
            popper-class="transparent-dropdown"
            :popper-append-to-body="false"
        >
          <el-option
              v-for="item in centralGovernment"
              :key="item.value"
              :label="item.title"
              :value="item.linkUrl"
          >
          </el-option>
        </el-select>


        <el-select
            v-model="provincialValue"
            placeholder="省级部门"
            @change="handleProvincialChange"
            popper-class="transparent-dropdown"
            :popper-append-to-body="false"
        >
          <el-option
              v-for="item in provincialList"
              :key="item.value"
              :label="item.title"
              :value="item.linkUrl"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- <div class="necessary_links">
      <div
        v-for="item in visibleLinks"
        :key="item.id"
        @click="openTankUrl(item)"
      >
        <div class="unit_img">
          <img
            :src="require('@/assets/recycling/magic/unit-icon.png')"
            :alt="item.title"
          />
        </div>
        <div class="unit_content">
          <p>{{ item.title }}</p>
          <p>{{ item.linkUrl }}</p>
        </div>
      </div>
      <button v-if="!isExpanded" class="expand-button" @click="toggleLinks">
        <i class="el-icon-arrow-down"></i>
      </button>
      <button v-if="isExpanded" class="collapse-button" @click="toggleLinks">
        <i class="el-icon-arrow-up"></i>
      </button>
    </div> -->
        <bottom-url/>
  </div>
</template>
<script>
import homeEcharts from '@/components/echartsMenu/homeEcharts.vue';
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import homeCard from '@/components/homeCard/homeCard.vue';
import {scrollTop} from '@/util/scrollTop';
import {getPunishmentList} from '@/API/news/news.js';
import {getHomeData} from '@/API/home/home.js';
import { Message } from 'element-ui';

export default {
  name: 'home',
  components: {
    homeEcharts,
    bottomUrl,
    homeCard,
  },
  data() {
    return {
      centralValue: '',
      provincialValue: '',
      partyCommitteeValue: '',
      qrCode: require('@/assets/recycling/oneClickRecycle/qrCode.png'),
      baseUrl: process.env.VUE_APP_BASE_URL,
      choseNum: 1,
      policy: [
        {
          title: '为什么不建议反复使用饮料瓶？可能暗藏健康风险！',
          time: '2025-04-12 10:20:30',
          content:
              '环保装备制造业是推动绿色低碳转型的重要基础。专家认为，《意见》从强化关键技术攻关、加快先进技术推广、培育行业发展新动能、优化产业发展环境等方面提出12项政策措施，将提...',
        },
        {
          title: '高铁废渣用于高标准农田建设',
          time: '2025-04-12 10:20:30',
          content:
              '环保装备制造业是推动绿色低碳转型的重要基础。专家认为，《意见》从强化关键技术攻关、加快先进技术推广、培育行业发展新动能、优化产业发展环境等方面提出12项政策措施，将提...',
        },
        {
          title: '这一年，城市副中心绿色发展成绩单更亮眼',
          time: '2025-04-12 10:20:30',
          content:
              '环保装备制造业是推动绿色低碳转型的重要基础。专家认为，《意见》从强化关键技术攻关、加快先进技术推广、培育行业发展新动能、优化产业发展环境等方面提出12项政策措施，将提...',
        },
      ],
      distribution: [
        {
          title: '回收网点总数',
          nums: '15424',
        },
        {
          title: '中转站总数',
          nums: '89',
        },
        {
          title: '分拣中心总数',
          nums: '56',
        },
        {
          title: '利废企业总数',
          nums: '286',
        },
      ],
      functionIntroduction: [
        {
          title: '全流程溯源',
          Introduction:
              '建立资源回收一物一码，实现物资回收利用全流程溯源记录、全链条信息展示、税足迹跟踪。',
          url: require('@/assets/recycling/magic/bg2.png'),
        },
        {
          title: '碳足迹管理',
          Introduction:
              '基于回收利用碳足迹测算服务对全过程的碳排放进行跟踪和监控，优化碳排放措施，促进全产业绿色低碳锩閆S待饦池硕发秏胸展。',
          url: require('@/assets/recycling/magic/bg5.png'),
        },
        {
          title: '溯源监管',
          Introduction:
              '全产业供应链业务实时监管，保障再生资源来源合法化、处理环保化、再利用高质化。',
          url: require('@/assets/recycling/magic/bg6.png'),
        },
        {
          title: '供应链金融',
          Introduction:
              '建立物流、资金流、信息流、台同流、发票流五流合一供应链金融体系，助力优化供应链体系，保障供应资金。',
          url: require('@/assets/recycling/magic/bg1.png'),
        },
        {
          title: '产业链大数据',
          Introduction:
              '利用大数据手段，对全产业链各环节数据进行实时监控、分析，优化产业链运作流程。',
          url: require('@/assets/recycling/magic/bg3.png'),
        },
        {
          title: '市场风控',
          Introduction:
              '基于A!大模型，建全产业链智能化风控测算体系，助力各环节业务风控监测与控制。',
          url: require('@/assets/recycling/magic/bg4.png'),
        },
        {
          title: '供需信息',
          Introduction:
              '连通各环节子平台，聚合全场景物资供需、仓储供需、物流供需等数据，助力供需对接。',
          url: require('@/assets/recycling/magic/bg7.png'),
        },
        {
          title: '交易撮合',
          Introduction:
              '汇聚各拍卖交易数据，提供商机查找、交易撮合、在线磋商等服务,促成上下游交易。',
          url: require('@/assets/recycling/magic/bg8.png'),
        },
      ],
      functionIntroductionImg: require('@/assets/recycling/index/supplyChain.svg'),
      quotation_left: require('@/assets/recycling/index/quotation_left.svg'),
      quotation_right: require('@/assets/recycling/index/quotation_right.svg'),
      titleImg: require('@/assets/recycling/index/circulate.svg'),
      instraction:
          '天府再生资源云”平台以“全省一张网”为基础，集资源回收、政府决策、用户服务等7大功能模块，通过数字化赋能，使全产业链各环节数据可见可追溯，提升整个行业的信息化水平和运营效率。，促进再生资源行业健康可持续发展。',
      necessaryLinksList: [
        {
          src: require('../../../public/home/gov.png'),
          name: '国务院',
          title: '国务院',
          url: 'https://www.gov.cn/',
          id: 9,
        },
        {
          src: require('../../../public/home/nationalD.png'),
          name: '国家发改委',
          title: '国家发改委',
          url: 'https://www.ndrc.gov.cn/',
          id: 10,
        },
        {
          src: require('../../../public/home/ministry.png'),
          name: '商务部',
          title: '商务部',
          url: 'https://m.mofcom.gov.cn/',
          id: 11,
        },
        {
          src: require('../../../public/home/chinaCoOp.png'),
          name: '中华供销总社',
          title: '中华供销总社',
          url: 'https://www.chinacoop.gov.cn/',
          id: 12,
        },
        {
          src: require('../../../public/home/govermment.png'),
          title: '四川省人民政府',
          url: 'https://www.sc.gov.cn/',
          id: 1,
        },
        {
          src: require('../../../public/home/commission.png'),
          title: '四川省发展和改革委员会',
          url: 'https://fgw.sc.gov.cn/',
          id: 2,
        },
        {
          src: require('../../../public/home/commerce.png'),
          title: '四川省商务厅',
          url: 'https://swt.sc.gov.cn/',
          id: 3,
        },
        {
          src: require('../../../public/home/scco-op.png'),
          title: '四川省供销合作社联合社',
          url: 'https://www.scco-op.com/',
          id: 4,
        },
        {
          src: require('../../../public/home/economy.png'),
          title: '四川省经济和信息化厅',
          url: 'https://jxt.sc.gov.cn/',
          id: 5,
        },
        {
          src: require('../../../public/home/zhufang.png'),
          title: '四川省住房和城乡建设厅',
          url: 'http://jst.sc.gov.cn/',
          id: 6,
        },
        {
          src: require('../../../public/home/environment.png'),
          title: '四川省生态环境厅',
          url: 'https://sthjt.sc.gov.cn/',
          id: 7,
        },
        {
          src: require('../../../public/home/agriculture.jpg'),
          title: '四川省机关事务管理局',
          url: 'https://jgswj.sc.gov.cn/',
          id: 8,
        },
      ],
      magicData: [
        {
          title: '以旧换新',
          id: 2,
          imageUrl: require('@/assets/recycling/magic/产业升级.png'),
          subtitle: '“两新”政策推动消费增长与经济转型，成效显著,潜力巨大。',
          linkUrl: 'https://swt.sc.gov.cn/sccom/c240919/yjhx_index.shtml',
        },
        {
          title: '报废机动车',
          id: 4,
          imageUrl: require('@/assets/recycling/magic/便利性.png'),
          subtitle: '做好2025年机动车以旧换新工作，促进经济发展，利国利民。',
          linkUrl:
              'https://qjd.sczwfw.gov.cn/art/2020/9/3/art_14448_107416.html?areaCode=510000000000',
        },
        {
          title: '再生资源备案',
          id: 3,
          imageUrl: require('@/assets/recycling/magic/监管能力.png'),
          subtitle:
              '加快规范完善再生资源回收分拣网络，提升再生资源拆解加工水平。',
          linkUrl: 'https://www.mofcom.gov.cn/zwdt/zwdt/index.html',
        },
        {
          title: '废弃电子电器',
          id: 1,
          imageUrl: require('@/assets/recycling/magic/循环利用.png'),
          subtitle:
              '四川环保废弃电子电器数，全省5家废弃电器电子产品处理企业拆解处理情况。',
          linkUrl: 'https://sthjt.sc.gov.cn/sthjt/c103951/zclist.shtml',
        },
        {
          title: '利废企业',
          id: 5,
          imageUrl: require('@/assets/recycling/magic/waste-utilization.png'),
          subtitle:
              '四川环保废弃电子电器数，全省5家废弃电器电子产品处理企业拆解处理情况。',
          linkUrl: 'https://sthjt.sc.gov.cn/sthjt/c103951/zclist.shtml',
        },
      ],
      newData: [],
      bannerImg: [],
      bannerStyle: {},
      isExpanded: false, // 控制展开状态
      isAutoplay: true
    };
  },
  mounted() {
    this.getArticleList();
    this.getHomeData();
  },
  computed: {
    visibleLinks() {
      return this.isExpanded
          ? this.necessaryLinksList
          : this.necessaryLinksList.slice(0, 4);
    },
    provincialList() {
      return this.necessaryLinksList.filter(
          (item) => item.extraData?.dataType == 3,
      );
    },
    centralGovernment() {
      return this.necessaryLinksList.filter(
          (item) => item.extraData?.dataType == 2,
      );
    },
    partyCommittee() {
      return this.necessaryLinksList.filter(
          (item) => item.extraData?.dataType == 1,
      );
    }
  },
  methods: {
    pauseCarousel() {
      this.isAutoplay = false;
      this.$refs.carousel && this.$refs.carousel.setActiveItem(this.$refs.carousel.activeIndex);
    },
    startCarousel() {
      this.isAutoplay = true;
    },
    handleProvincialChange(value) {
      this.provincialValue = '';
      window.open(value);
    },
    handleCentralChange(value) {
      this.centralValue = '';
      window.open(value);
    },
    handlePartyCommitteeChange(value) {
      this.partyCommitteeValue = '';
      window.open(value);
    },
    toggleLinks() {
      this.isExpanded = !this.isExpanded;
    },
    getHomeData() {
      getHomeData('homePage').then((res) => {
        if (res.code == 200) {
          res.data.map((item) => {
            //Banner背景图片
            if (item.moduleKey === 'Banner') {
              // this.bannerImg = this.baseUrl + item.contents[0].imageUrl;
              this.bannerImg = item.contents.map((ite) => {
                return {...ite, url: this.baseUrl + ite.imageUrl};
              });
            }
            //栏目数据处理
            if (item.moduleKey === 'Column') {
              this.magicData = item.contents;
            }
            //指导单位数据处理
            if (item.moduleKey === 'Supervisory') {
              this.necessaryLinksList = item.contents;
            }
          });
        }
      });
    },
    detectDevice() {
      // 1. 检查用户代理字符串
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());

      // 2. 检查屏幕宽度（通常认为小于768px为移动设备）
      const isSmallScreen = window.innerWidth <= 768;

      // 3. 检查是否支持触摸
      const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      // 4. 结合多个条件判断
      // 如果用户代理显示是移动设备或者屏幕较小且有触摸支持，则认为是移动设备
      if (isMobileUA || (isSmallScreen && hasTouchSupport)) {
        return "Mobile";
      } else {
        return "PC";
      }
    },
    gotoDetail(data) {
      if(data.title == '全流程溯源' && this.detectDevice()== 'Mobile') {
        Message.closeAll();
        Message({
          type: 'error',
          message: '移动端不允许查看，请使用pc端。',
          center: true,
          showClose: true,
          offset: 80,
        });
        return;
      }
      let pathArr = {
        全流程溯源: '/wholeProcess',
        碳足迹管理: '/secondaryHomepage/carbonFootprint',
        溯源监管: '/secondaryHomepage/traceabilitySupervision',
        供应链金融: '/secondaryHomepage/supplyChain',
        产业链大数据: '/secondaryHomepage/industrialChain',
        市场风控: '/secondaryHomepage/marketRiskControl',
        供需信息: '/secondaryHomepage/supplyDemand',
        交易撮合: '/secondaryHomepage/transactionMatching',
      };
      this.$router.push(pathArr[data.title] || '/home');
    },
    jumpBtn(item) {
      if (item.linkUrl) {
        if (item.linkType == 1) {
          this.$router.push({
            name: item.linkUrl,
            params: {isValue: true},
          });
        } else {
          window.open(item.linkUrl);
        }
      }
    },
    jumpToAbout() {
      this.$router.push('/Home/aboutUs');
      this.$store.commit('updateRouterClickStatus', '/Home/aboutUs');
      scrollTop();
    },
    getArticleList() {
      let newList = [];
      getPunishmentList(this.form).then((res) => {
        if (res.code === 200) {
          // 当栏目数量>=4时，取前4个栏目的第一条
          if (res.data.length >= 4) {
            const firstFourColumns = res.data.slice(0, 4);
            firstFourColumns.forEach((column) => {
              if (column.articles && column.articles.length > 0) {
                newList.push(column.articles[0]);
              }
            });
          } else {
            // 当栏目数量<4时
            res.data.forEach((column) => {
              // 每个栏目取第一条
              if (column.articles && column.articles.length > 0) {
                newList.push(column.articles[0]);
              }
            });

            // 如果还不足4条，从现有栏目中随机取第二条或第三条
            while (newList.length < 4 && res.data.length > 0) {
              // 随机选择一个栏目
              const randomColumn =
                  res.data[Math.floor(Math.random() * res.data.length)];

              // 找出该栏目中尚未被选取的文章
              const availableArticles = randomColumn.articles.filter(
                  (article) => !newList.some((item) => item.id === article.id),
              );

              // 如果有可用的文章，取第一条可用的
              if (availableArticles.length > 0) {
                newList.push(availableArticles[0]);
              } else {
                // 如果所有文章都已被选取，跳出循环避免无限循环
                break;
              }
            }
          }

          // 为每条数据添加imageUrl字段
          newList = newList.map((article, index) => {
            const num = (index % 4) + 1; // 循环使用4张图片
            let imagePath = require(`@/assets/recycling/magic/image${num}.png`);
            if (article.coverImage) {
              imagePath = this.baseUrl + article.coverImage;
            }
            return {
              ...article,
              imageUrl: imagePath,
            };
          });

          this.newData = newList;
        }
      });
    },
    // 固定链接跳转
    openTankUrl(data) {
      window.open(data.linkUrl);
    },
    moveHome() {
      this.showCardInfo = false;
      scrollTop();
    },
    lookMoreNews(info) {
      this.$router.push({
        name: 'policyInformation',
        path: '/Home/policyInformation',
        params: {
          info: {
            breadList: ['政策新闻', info.title],
            newsId: info.id,
          },
        },
      });
    },
    lookMore() {
      this.$router.push({
        name: 'policyInformation',
        path: '/Home/policyInformation',
      });
    },
    lookDetail(value) {
      this.$router.push({
        name: 'policyInformation',
        path: '/Home/policyInformation',
        params: {info: {newsId: value.id}},
      });
    },
  },
};
</script>
<style scoped lang="less">
/* 媒体查询：小屏适配（屏幕宽度 ≤ 768px） */
@media screen and (max-width: 768px) {
  /* 轮播图适配 */
  .content {
    height: 200px !important;
    margin-bottom: 20px;

    /deep/ .el-carousel__container {
      height: 200px !important;
    }
  }

  /* 政策资讯 模块 */
  .consultation {
    padding-bottom: 10px;
    .consultation-container {
      width: 100%;
      padding: 0 15px;
      flex-wrap: wrap;
      gap: 15px;
    }

    .consultation-item {
      flex: 0 0 100%;
      min-width: auto;

      .consultation-image {
        height: 180px;
      }

      .consultation-content {
        padding: 10px;
      }

      .consultation-title {
        font-size: 14px;
      }
    }

    .consultation-more {
      display: none;
    }

    .image-hover-title {
      font-size: 18px !important;
      font-weight: bold;
      color: white;
      text-align: left;
      margin-bottom: 15px;
    }

    .more {
      display: block !important;
      width: 80px;
      //height: 24px;
      border: 1px solid rgba(153, 153, 153, 1);
      border-radius: 2px;
      line-height: 24px;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      text-align: center;

    }
  }

  /* 友情链接 模块 */
  .necessary_link {
    height: auto !important;
    padding: 15px !important;
    p {
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: unset !important;
    }

    .item {
      display: unset !important;
    }

    /deep/ .el-input {
      width: unset !important;
      height: unset !important;
    }

    /* 自定义Element UI样式 */

    /deep/ .el-select {
      width: 100% !important;
      height: unset !important;
    }

    /deep/ .el-input__inner {
      height: 40px !important;
      font-size: 14px !important;
      &::placeholder {
        color: rgba(51, 51, 51, 1);
        font-size: 14px !important;
      }
    }
    /deep/ .el-input__icon {
      font-size: 16px !important;
    }
    // 添加透明下拉框的样式
    /deep/ .transparent-dropdown {
      max-height: unset !important; // 最多显示5个选项
      overflow-y: unset !important; // 超出滚动
      .el-select-dropdown__item {
        background: transparent;
        &:hover {
          background: rgba(67, 207, 124, 0.1);
        }
      }
    }
  }

  /* 通用标题适配 */
  .common_title {
    font-size: 32px !important;
    margin-top: 25px;
  }
}

.consultation-container {
  width: 1415px;
  display: flex; /* 弹性布局实现同行 */
  gap: 20px; /* 项目间距 */
  overflow-x: auto; /* 允许横向滚动 */
  // padding-bottom: 10px; /* 给滚动条留空间 */
  justify-content: center;
  /* 隐藏滚动条但保留功能 */
  scrollbar-width: none; /* Firefox */

  .more {
    display: none;
  }

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
}

.consultation-item {
  flex: 0 0 24%; /* 不伸缩不收缩，基础宽度31% */
  min-width: 280px; /* 最小宽度防止过小 */
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
}

.consultation-item:hover .image-hover-content {
  opacity: 1;
}

.consultation-image {
  height: 301px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
  }

  &:hover img {
    transform: scale(1.05);
  }

  .image-hover-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: start;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: 0 22px;
  }

  .image-hover-title {
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: left;
    margin-bottom: 15px;
  }

  .view-details-btn {
    background: rgba(112, 200, 170, 1);
    color: white;
    border: none;
    padding: 3px 12px;
    border-radius: 2px;
    cursor: pointer;
  }
}

.consultation-content {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  color: rgba(102, 102, 102, 1);
  padding: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.consultation-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(51, 51, 51, 1);
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 省略号 */
  margin-bottom: 14px;
}

.consultation-time {
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}

// .consultation-text {
//   flex: 1;
//   color: #666;
//   font-size: 14px;
//   line-height: 1.5;
//   display: -webkit-box;
//   -webkit-line-clamp: 3; /* 限制3行 */
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   margin-bottom: 10px;
// }
.consultation-text {
  /* 确保内容正常换行 */
  white-space: normal;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制显示3行 */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  /* 重置内部元素样式 */

  ::v-deep * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* 防止图片或浮动元素导致重叠 */

  ::v-deep img {
    max-width: 100%;
    height: auto;
    display: none;
  }
}

.consultation-more {
  width: 60px;
  height: 28px;
  border: 1px solid rgba(153, 153, 153, 1);
  line-height: 28px;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  text-align: center;
  margin-top: 22px; /* 推到底部 */
  box-sizing: border-box;
}

.content {
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  /deep/ .el-carousel__container {
    height: 100%;
  }

  .content_item {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  // .Introduction {
  //   position: absolute;
  //   bottom: 28px;
  // }
}

.common_title {
  width: 100%;
  text-align: center;
  margin-top: 44px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #333333;
  font-size: 24px;
}

.common_description {
  width: 100%;
  text-align: center;
  letter-spacing: 1px;
  color: rgba(112, 112, 112, 1);
  margin-top: 7px;
  margin-bottom: 36px;
  font-weight: 400;
  font-size: 18px;
}

.one_click_recycling {
  height: 556px;
  width: 100%;
  box-sizing: border-box;
  background: url('~@/assets/recycling/index/recycling-bg.png') no-repeat;
  background-size: cover;
  padding: 69px 259px;
  box-sizing: border-box;

  .title {
    width: 100%;
    text-align: center;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;
    color: rgba(51, 51, 51, 1);
  }

  .recycling_content {
    width: 791px;
    height: 420px;
    opacity: 1;
    background: linear-gradient(90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%);
    backdrop-filter: blur(20px);
    padding: 25px 15px 33px 37px;
    box-sizing: border-box;

    .recycling_descript {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 32px;
      color: rgba(0, 0, 0, 1);
    }

    .QR_code {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;

      img {
        width: 200px;
        height: 186.67px;
        border-radius: 20px;
      }

      p {
        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 32px;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
}

/deep/ .el-carousel__indicators--horizontal {
  left: 50% !important;
  white-space:nowrap !important;
}

.content-footer {
  position: relative;
  height: 130px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  top: -65px;

  .content-footer_warpper {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    top: 0;

    /deep/ .el-carousel__container {
      width: 1500px;

      .carousel-content {
        position: relative;
        height: 130px;
        left: 150px;
        top: 0;
      }

      .el-carousel__item--card {
        width: auto;
      }
    }

    /deep/ .el-carousel__indicators {
      display: none;
    }
  }

  .module-item {
    display: flex;
    align-items: center;
    width: 400px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;

    img {
      width: 100%;
    }
  }
}

.ProductIntroduction {
  margin-top: 110px;

  .product-introduction {
    margin: 0 auto;
    width: 1400px;
    margin-top: 45px;

    img {
      width: 1400px;
    }
  }

  .ProductIntroduction_backgr {
    margin: 0 auto;
    width: 360px;
    height: 60px;
    opacity: 1;
    border-radius: 50px;
    background: rgba(250, 250, 250, 1);
    display: flex;
    align-items: center;
    justify-content: center;

    .ProductIntroduction_backgr_title {
      display: flex;

      img {
        margin-right: 15px;
      }

      span {
        font-size: 40px;
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 57.92px;
        color: rgba(51, 51, 51, 1);
        text-align: left;
      }
    }

    .ProductIntroduction_backgr_btn {
      width: 180px;
      height: 60px;
      opacity: 1;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 1px;
      color: rgba(51, 51, 51, 1);
    }

    .ProductIntroduction_backgr_btn:hover {
      background: linear-gradient(90deg,
      rgba(26, 190, 107, 1) 0%,
      rgba(118, 216, 166, 1) 100%);
      color: #ffffff;
    }

    .addChoseBackground {
      background: linear-gradient(90deg,
      rgba(26, 190, 107, 1) 0%,
      rgba(118, 216, 166, 1) 100%);
      color: #ffffff;
    }
  }

  .ProductIntroduction_info {
    margin-top: 45px;
    width: 100%;
    display: flex;
    justify-content: center;

    .ProductIntroduction_info_warpper {
      width: 1025px;

      .ProductIntroduction_info_warpper_quotation {
        color: rgba(113, 214, 162, 1);
      }

      .ProductIntroduction_info_warpper_content {
        /** 文本1 */
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding: 10px 37px;
      }

      .ProductIntroduction_info_warpper_quotation_left {
        display: flex;
        justify-content: right;
      }
    }
  }
}

.Business {
  height: 745px;

  .info_left {
    margin-right: 15px;

    .info_left_top,
    .info_left_btm {
      width: 634px;
      height: 364px;
      opacity: 1;
    }

    .info_left_top {
      margin-bottom: 15px;
      background: url('~@/assets/recycling/magic/rabit.png') center no-repeat;
      background-size: cover;
      position: relative;
    }

    .info_left_btm {
      background: url('~@/assets/recycling/magic/rabit.png') center no-repeat;
      background-size: cover;
      position: relative;
    }
  }

  .info_right {
    .info_right_top {
      width: 750px;
      height: 470px;
      background: url('~@/assets/recycling/magic/xuanwo.png') center no-repeat;
      margin-bottom: 15px;
      position: relative;

      .Integral {
        position: absolute;
        left: 0;
        top: 0;
        padding: 50px;

        h2 {
          font-size: 28px;
          font-weight: 700;
          letter-spacing: 1px;
          line-height: 40.54px;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 13px;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          line-height: 20.27px;
          color: rgba(255, 255, 255, 1);
          text-align: left;
        }
      }
    }

    .info_right_btm {
      display: flex;

      .info_right_btm_left {
        width: 367px;
        height: 258px;
        opacity: 1;
        border-radius: 3.84px;
        background: rgba(67, 207, 124, 1);
        box-shadow: 0px 3px 10px rgba(143, 143, 143, 0.15);
        margin-right: 15px;
      }

      .info_right_btm_right {
        width: 367px;
        height: 258px;
        opacity: 1;
        border-radius: 3.84px;
        background: rgba(27, 191, 191, 1);
        box-shadow: 0px 3px 10px rgba(143, 143, 143, 0.15);
      }

      .info_right_btm_left,
      .info_right_btm_right {
        position: relative;
        padding: 30px;

        .images {
          img {
            width: 60px;
          }
        }

        .text {
          position: absolute;
          padding: 30px;
          bottom: 0;
          left: 0;

          h2 {
            font-size: 28px;
            font-weight: 700;
            letter-spacing: 1px;
            line-height: 40.54px;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 13px;
          }

          p {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 1px;
            line-height: 20.27px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
          }
        }
      }
    }
  }
}

.instaion {
  padding: 30px;
  position: absolute;
  bottom: 0;
  left: 0;

  h2 {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 40.54px;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 20.27px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
  }
}

.Introduction {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .Introduction_card {
    width: 1253px;
    height: 134px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .MagicCard {
    width: 222px;
    border-radius: 16px;
    background: #61d3f2;
    display: flex;
    cursor: pointer;
    box-sizing: border-box;
    padding: 14px 20px;

    .Card_content {
      .text {
        p {
          font-size: 18px;
          font-weight: 500;
          letter-spacing: 1px;
          color: #61d3f2;
        }
      }

      .Card_img {
        display: flex;
        align-items: center;
        justify-content: start;

        img {
          width: 47px;
          margin-right: 7px;
        }

        span {
          color: rgba(0, 0, 0, 1);
          font-size: 20px;
          font-weight: 500;
          letter-spacing: 1px;
        }
      }
    }
  }

  .MagicCard:hover {
    background: rgba(67, 207, 124, 1);

    .Card_content {
      .text {
        p {
          color: rgba(255, 255, 255, 1);
        }
      }

      .Card_img {
        span {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}

.canWeDo {
  width: 100%;
  opacity: 1;
  background: rgba(250, 250, 250, 1);
  margin-top: 30px;
  padding: 0 20px 40px;
  box-sizing: border-box;

  .canWeDo_title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 57.92px;
    color: rgba(51, 51, 51, 1);
    padding-bottom: 60px;

    img {
      margin-right: 15px;
    }
  }

  .canWeDo_box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .canWeDo_warpper {
      width: 73.69792vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      gap: 20px;

      .canWeDo_warpper_card {
        position: relative;
        cursor: pointer;
        flex: 0 0 330px;
        border: 1px;
        overflow: hidden;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        .canWeDo_warpper_card_title,
        .canWeDo_warpper_card_img,
        .canWeDo_warpper_card_content {
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .canWeDo_warpper_card_title {
          img {
            width: 100%;
            height: auto;
            display: block;
            object-fit: cover;
          }
        }
      }
    }
  }
}
/* 移动端适配（768px以下） */
@media screen and (max-width: 768px) {
  .canWeDo {
    padding: 0 15px 30px;

    .canWeDo_box {
      .canWeDo_warpper {
        width: 100%;
        justify-content: space-between;
        gap: 15px;

        .canWeDo_warpper_card {
          flex: 0 0 calc(50% - 8px);
        }
      }
    }
  }
}

.Outlets {
  height: 956px;
  margin-top: 30px;
  background: linear-gradient(225deg,
  rgba(255, 255, 255, 0.75) 0%,
  rgba(255, 255, 255, 1) 38.09%,
  rgba(255, 255, 255, 0.6) 100%);

  .Outlets_warpper {
    width: 100%;
    height: 956px;
    background: url('~@/assets/recycling/index/OutletsImg.png') no-repeat;
    background-size: cover;

    .Outlets_title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 57.92px;
      color: rgba(51, 51, 51, 1);
      padding: 60px 0;

      img {
        margin-right: 15px;
      }
    }

    .Outlets_content {
      height: 684px;
      display: flex;

      .Outlets_content_left {
        width: 508px;
        height: inherit;
        display: flex;
        justify-content: right;

        .Outlets_content_left_box {
          width: 141px;
        }

        .Outlets_content_left_totle {
          width: 141px;
          height: 116px;
          margin-bottom: 48px;

          .Outlets_content_left_totle_name {
            font-size: 20px;
            font-weight: 400;
            letter-spacing: 1px;
          }

          .Outlets_content_left_totle_nums {
            font-size: 60px;
            font-weight: 500;
            letter-spacing: 1px;
            color: rgba(45, 173, 109, 1);
            line-height: 80px;
          }
        }
      }

      .Outlets_content_right {
        width: calc(100% - 508px);
        height: inherit;
      }
    }
  }
}

.product_explanation {
  display: flex;
  justify-content: center;
  width: 100%;

  .product_content {
    width: 1410px;
    height: 678px;
    background: url('~@/assets/recycling/index/main-bg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease;
    position: relative;

    &:hover {
      transform: translateY(-5px);

      .product_overlay {
        opacity: 1;
      }

      .about-us-link {
        opacity: 1;
        transform: translateY(0);
      }
    }

    /* 蒙层效果 */

    .product_overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      transition: opacity 0.4s ease;
      z-index: 1;
    }

    /* 关于我们链接 */

    .about-us-link {
      position: absolute;
      top: 246px;
      left: 651px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-decoration: none;
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.4s ease;
      z-index: 2;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        padding-bottom: 4px;
        border-bottom: 1px solid #fff;
        transition: all 0.3s ease;
      }
    }
  }
}

.consultation {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 50px;

  .consultation_warpper_title {
    width: inherit;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 57.92px;
    color: rgba(51, 51, 51, 1);
    padding: 60px 0;

    img {
      margin-right: 15px;
    }
  }

  .consultation_warpper {
    width: 1400px;
    height: 430px;
    background-color: #fafafaff;
    display: flex;

    .consultation_warpper_left,
    .consultation_warpper_right {
      width: 50%;
      height: inherit;
    }

    .consultation_warpper_right {
      background-color: #ffffff;
      padding: 30px;

      .consultation_warpper_right_policy {
        height: 108px;
        margin-bottom: 20px;

        .consultation_warpper_right_policy_title {
          font-size: 20px;
          font-weight: 500;
          letter-spacing: 1px;
          line-height: 28.96px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 10px;
          cursor: pointer;
        }

        .consultation_warpper_right_policy_title:hover {
          color: rgba(143, 143, 143, 0.76);
        }

        .consultation_warpper_right_policy_time {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          line-height: 17.38px;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 10px;
        }

        .consultation_warpper_right_policy_content {
          font-size: 16px;
          font-weight: 400;
          height: 46px;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          letter-spacing: 1px;
          color: rgba(153, 153, 153, 1);
        }
      }
    }

    .consultation_warpper_left {
      background: url('~@/assets/recycling/index/consultation.png') no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      .specification {
        background: linear-gradient(180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.78) 100%);
        padding: 0 37px;

        .specification_title {
          font-size: 24px;
          font-weight: 500;
          letter-spacing: 1px;
          line-height: 34.75px;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
        }

        .specification_title:hover {
          color: #c7c6c6c1;
        }

        .specification_line {
          height: 1px;
          opacity: 0.3;
          background: #ffffffff;
          margin: 14px 0;
        }

        .specification_text {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          line-height: 20.27px;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 22px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

.showMore {
  height: 148px;
  display: flex;
  justify-content: center;
  align-items: center;

  .showMore_btn {
    width: 100px;
    height: 40px;
    opacity: 1;
    border: 1px solid #000000;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 17.38px;
    color: #000000;
    border-radius: 2px;
  }

  .showMore_btn:hover {
    border: 1px solid rgba(143, 143, 143, 0.76);
    color: rgba(143, 143, 143, 0.76);
  }
}

.necessary_link {
  width: 100%;
  height: 130px;
  opacity: 1;
  background: rgba(237, 247, 241, 1);
  box-sizing: border-box;
  padding: 15px 248px 0;

  p {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 20.27px;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 16px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-input {
    width: 430px;
    height: 40px;
  }

  /* 自定义Element UI样式 */

  /deep/ .el-input.is-disabled .el-input__inner {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    color: #6b7280;
    cursor: not-allowed;
    border: 1px solid rgba(67, 207, 124, 1);
    box-sizing: border-box;
  }

  /deep/ .el-select {
    width: 430px;
    height: 40px;
  }

  /deep/ .el-input__inner {
    height: 40px;
    font-size: 16px;
    border: 1px solid rgba(67, 207, 124, 1);
    box-sizing: border-box;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);

    &::placeholder {
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
    }
  }

  /deep/ .el-input__icon {
    font-size: 18px;
  }

  // 添加透明下拉框的样式
  /deep/ .transparent-dropdown {
    // background: transparent !important;
    // border: 1px solid rgba(67, 207, 124, 1);
    // backdrop-filter: blur(10px); // 添加模糊效果
    max-height: 180px; // 最多显示5个选项
    overflow-y: auto; // 超出滚动
    .el-select-dropdown__item {
      background: transparent;

      &:hover {
        background: rgba(67, 207, 124, 0.1);
      }
    }
  }
}

.necessary_links {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  border-radius: 9px;
  gap: 24px 70px;
  background: rgba(51, 51, 51, 1);
  width: 1415px;
  margin: 0 auto;
  padding: 30px 130px 30px 50px;
  position: relative;
  margin-bottom: -30px;

  .expand-button {
    position: absolute;
    top: 40px;
    right: 50px;
    font-size: 25px;
    color: #fff;
  }

  .collapse-button {
    position: absolute;
    bottom: 30px;
    right: 50px;
    font-size: 25px;
    color: #fff;
  }

  & > div {
    width: 250px;
    display: flex;
    justify-content: start;
    align-items: center;
    cursor: pointer;
  }

  .unit_img {
    border: 1px solid rgba(255, 255, 255, 1);
    width: 33px;
    height: 33px;
    margin-right: 10px;
  }

  .unit_content {
    color: #fff;
    font-weight: 400;
    flex: 1;

    p:first-child {
      width: 200px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p:last-child {
      font-size: 14px;
    }
  }
}
</style>
